import { MOBILE_BREAKPOINT_THRESHOLD, SxProps } from '@cp/ds';
import { StackProps } from '@cp/ds/src/components/stack';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { ToastCssTokens } from './const';

const defaultStyles: SxProps = (theme) => ({
  width: '100%',
  maxWidth: 400,
  paddingX: 2.5,
  paddingY: 1.25,
  position: 'absolute',

  [theme.breakpoints.down(MOBILE_BREAKPOINT_THRESHOLD)]: {
    paddingX: 1.25,
    maxWidth: 'none',
  },
});

export const TOP_LEFT_PROPS: StackProps = {
  flexDirection: 'column',
  sx: mergeSx(
    {
      top: ToastCssTokens.topOffset('0px'),
      left: 0,
    },
    defaultStyles,
  ),
};

export const TOP_RIGHT_PROPS: StackProps = {
  flexDirection: 'column',
  sx: mergeSx(
    {
      top: ToastCssTokens.topOffset('0px'),
      right: 0,
    },
    defaultStyles,
  ),
};

export const TOP_CENTER_PROPS: StackProps = {
  flexDirection: 'column',
  sx: mergeSx(
    {
      top: ToastCssTokens.topOffset('0px'),
      left: '50%',
      transform: 'translateX(-50%)',
    },
    defaultStyles,
  ),
};

export const BOTTOM_LEFT_PROPS: StackProps = {
  flexDirection: 'column',
  sx: mergeSx(
    {
      bottom: ToastCssTokens.bottomOffset('0px'),
      left: 0,
    },
    defaultStyles,
  ),
};

export const BOTTOM_RIGHT_PROPS: StackProps = {
  flexDirection: 'column',
  sx: mergeSx(
    {
      bottom: ToastCssTokens.bottomOffset('0px'),
      right: 0,
    },
    defaultStyles,
  ),
};

export const BOTTOM_CENTER_PROPS: StackProps = {
  flexDirection: 'column',
  sx: mergeSx(
    {
      bottom: ToastCssTokens.bottomOffset('0px'),
      left: '50%',
      transform: 'translateX(-50%)',
    },
    defaultStyles,
  ),
};
